<template>
  <div class="app-container" style="text-align: left">
    <div style="margin-left: 0px">
      <div>
        <el-switch
          :active-value="1"
          active-color="#0850fc"
          :inactive-value="0"
          inactive-color="rgb(187 187 187)"
          v-model="sms_auto"
          @change="autoSendSmsOnOff()"
        />
        &nbsp;&nbsp;&nbsp;
        <span style="font-size: 15px; font-weight: bold">短信自动发送</span>
        <el-button
          type="primary"
          style="
            font-size: 13px;
            background-color: #0850fc;
            color: white;
            border-radius: 0.5em;
            margin-left: 20px;
          "
          @click="smsZdSendInfo"
          >设置</el-button
        >
        <span style="margin-left: 20px; font-weight: bold">￥0.15/条</span>
      </div>
      <div
        class="select_span"
        style="margin-left: 0px; padding-bottom: 5px; width: 200px; margin-top: 15px"
      >
        <span style="padding: 0 10px 0 10px; border-right: #c3c3c3 solid 1px"
          >手机号</span
        >
        <input v-model="csPhoneNum" style="width: 110px" class="filter-item" clearable />
      </div>
      <div style="margin-left: 220px; margin-top: -32px">
        <el-button type="primary" @click="sendCsSms()">短信测试</el-button>
        <span>（第一条免费，之后开始收费）</span>
      </div>

      <div
        class="select_span"
        style="
          margin-left: 0px;
          margin-top: 15px;
          padding-bottom: 5px;
          width: 438px;
          height: 33px;
        "
      >
        <span style="padding: 0 10px 0 10px">成交时间</span>
        <date-picker
          v-model="startDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始日期"
          :picker-options="pickerOptionsStart"
          class="borderless"
        ></date-picker>
        <span>至&nbsp;</span>
        <date-picker
          v-model="endDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束日期"
          :picker-options="pickerOptionsEnd"
          class="borderless"
        ></date-picker>
      </div>

      <div
        class="select_span"
        style="margin-left: 450px; margin-top: -32px; padding-bottom: 5px; width: 270px"
      >
        <span style="padding: 0 10px 0 10px; border-right: #c3c3c3 solid 1px"
          >订单编号</span
        >
        <input
          v-model="listQuery.order_no"
          style="width: 180px"
          class="filter-item"
          clearable
        />
      </div>

      <div
        class="select_span"
        style="margin-left: 732px; margin-top: -32px; padding: 0px 10px; width: 174px"
      >
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 10px">短信状态</span>
        <select v-model="listQuery.status" class="filter-item" style="width: 80px">
          <option
            v-for="item in orderStasList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </select>
      </div>
      <div
        class="select_span"
        style="margin-left: 918px; margin-top: -32px; padding: 0px 10px; width: 110px"
      >
        <select v-model="listQuery.orderField" class="filter-item" style="width: 95px">
          <option
            v-for="item in timeStasList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </select>
      </div>
      <div
        class="select_span"
        style="margin-left: 1040px; margin-top: -32px; padding: 0px 10px; width: 85px"
      >
        <select v-model="listQuery.orderType" class="filter-item" style="width: 70px">
          <option
            v-for="item in sortList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </select>
      </div>

      <div style="margin-left: 1140px; margin-top: -32px">
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="primary" @click="sendSms">手动发送短信</el-button>
      </div>
    </div>
    <div
      style="font-weight: bold; font-size: 20px; color: rgb(85, 85, 85); margin-top: 20px"
    >
      短信列表
    </div>
    <div style="width: 86vw; max-height: 550px; overflow-y: scroll">
      <el-table
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        style="max-width: 86vw; color: rgb(70, 70, 70); margin-top: 10px"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '3px 0' }"
        :header-cell-style="{
          background: 'rgb(247 248 252) !important',
          color: '#ededed  !important',
          padding: '7px 0',
          color: 'rgb(140, 140, 140)',
        }"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50px"
          fixed="left"
          align="left"
          checked="allChecked"
        >
        </el-table-column>
        <el-table-column label="序号" width="50px" align="left">
          <template slot-scope="{ row }">
            <span>{{ row.idx }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台" align="left" width="85px">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="platList[row.platform]">{{
              platList[row.platform]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺名称" align="left" width="85px">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.shop_name">{{ row.shop_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" width="180px" align="left">
          <template slot-scope="{ row }">
            <span>{{ row.order_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收货人" width="80px" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.addressee">{{ row.addressee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收货电话" align="left" width="110px">
          <template slot-scope="{ row }">
            <span>{{ row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收货地址" width="100px" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.town">{{ row.town }}</span>
          </template>
        </el-table-column>
        <el-table-column label="采购平台" width="80px" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.cg_platform">{{ row.cg_platform }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物流公司" width="85px" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.express_pro">{{ row.express_pro }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" align="left" width="130px">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.express_no">{{ row.express_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="取件码" width="100px" align="left">
          <template slot-scope="{ row }">
            <span>{{ row.express_code }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代收点" width="130px" align="left">
          <template slot-scope="{ row }">
            <span>{{ row.express_company }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代收点电话" align="left" width="100px">
          <template slot-scope="{ row }">
            <span>{{ row.express_contact_mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发送状态" align="left" width="100px">
          <template slot-scope="{ row }">
            <span>{{ row.express_code_sent | statusFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" align="left" width="120px">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.express_code_senttime">{{
              row.express_code_senttime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成交时间" align="left" width="120px">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.trade_time">{{ row.trade_time }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.perPage"
      :page-sizes="[10]"
      style="padding-top: 12px; padding-bottom: 0px; text-align: left"
      @pagination="getList"
    />

    <!-- 自动发送短信 弹出框 -->
    <el-dialog
      title="自动发送短信"
      :visible.sync="dialogFormVisible"
      style="
        text-align: left;
        width: 60%;
        height: 120%;
        overflow-y: auto;
        padding: 0px;
        margin-left: 15%;
      "
    >
      <el-form
        class="form"
        :model="dataTemp"
        :rules="rules"
        ref="dataForm"
        label-width="150px"
      >
        <el-form-item label="每天定时发送时间段">
          <input
            style="border: rgb(220 223 230) 1px solid"
            type="time"
            v-model="start_time"
          />
          至

          <input
            style="border: rgb(220 223 230) 1px solid"
            type="time"
            v-model="end_time"
          />
          <!-- <el-time-picker
            style="width: 150px"
            v-model="start_time"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            placeholder="选择起始时间"
          ></el-time-picker> -->
          <!-- <el-time-picker
            style="width: 150px"
            v-model="end_time"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            placeholder="选择截止时间"
          ></el-time-picker> -->
        </el-form-item>
        <el-form-item label="自动发送最近天数" prop="days">
          <el-input
            type="number"
            min="0"
            v-model="dataTemp.day"
            style="width: 100px"
            class="filter-item"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoSendSmsOn()"> 保存 </el-button>
        <el-button @click="dialogFormVisible = false"> 取消 </el-button>
      </div>
    </el-dialog>

    <!-- 短信发送 返回数据展示弹出框 -->
    <el-dialog
      title="发送结果"
      :visible.sync="fsjgDialogFormVisible"
      style="
        text-align: center;
        width: 100%;
        height: 120%;
        overflow-y: auto;
        padding: 0px;
      "
    >
      <el-form
        :model="dxfsResult"
        style="
          width: 100%;
          height: 100%;
          overflow-y: auto;
          white-space: pre-line;
          text-align: left;
          margin-top: -50px;
        "
      >
        <el-form-item style="padding: 0; margin: 0">
          <span>
            {{ dxfsResult.data }}
          </span></el-form-item
        >
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import waves from "@/directive/waves"; // waves directive
// import "@/assets/custom-theme/index.css"; // the theme changed version element-ui css
import { DatePicker } from "element-ui";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
// import MaskLayer from "../MaskLayer.vue"; // 遮罩层
import horizontalScroll from "el-table-horizontal-scroll";
import moment from "moment";
import { RadioGroup, Radio } from "element-ui";

export default {
  name: "sms",
  directives: { waves, horizontalScroll },
  components: {
    Pagination,
    "el-date-picker": DatePicker,
    "el-radio-group": RadioGroup,
    "el-radio": Radio,
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: "未发送",
        1: "已发送",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      userToken: Cookies.get("view_userToken"),
      sms_auto: 0,
      listQuery: {
        page: 1,
        perPage: 10,
        date_one: "",
        date_two: "",
        order_no: "",
        status: 0,
        orderField: "trade_time",
        orderType: "desc",
      },
      list: [],
      total: 0,
      listLoading: false,
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        new Date().getDate()
      ).toLocaleString(),
      endDate: new Date().toLocaleString(),
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime(); // 选则的时间
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      shopGroupList: [],
      shopList: [],
      orderStasList: [
        { value: 0, name: "未发送" },
        { value: 1, name: "已发送" },
      ],
      timeStasList: [
        { value: "express_code_senttime", name: "发送时间" },
        { value: "trade_time", name: "成交时间" },
      ],
      sortList: [
        { value: "asc", name: "升序" },
        { value: "desc", name: "降序" },
      ],

      multipleSelection: [], // 被选中的行
      allSelectedDatas: [], // 被选中的行
      allChecked: true,
      dialogFormVisible: false,

      start_time: "",
      end_time: "",
      dataTemp: {
        dingshi_1: this.start_time,
        dingshi_2: this.end_time,
        day: "",
      },
      rules: {
        day: [{ required: true, message: "请输入发送天数", trigger: "blur" }],
      },
      csPhoneNum: "",
      sdfsQuery: {
        list: [],
        _token: "",
      },
      fsjgDialogFormVisible: false,
      dxfsResult: { data: "" },
      platList: {
        1: "淘宝",
        2: "淘特",
        3: "拼多多",
        4: "天猫",
        5: "1688",
        6: "抖音",
        7: "孔夫子",
        8: "小红书",
        9: "快手",
        10: "淘工厂",
        11: "咸鱼",
      },
    };
  },
  created() {
    // 判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
          return;
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
          return;
        });
      return;
    } else {
      this.$root.getUserInfo();
      const sms_auto = Cookies.get("view_sms_auto");
      if (sms_auto == 1 || sms_auto == "1") {
        this.sms_auto = 1;
      }
      this.$root.getSystemInfo();
      this.getList();
    }
  },
  mounted() {
    // this.getList();
    this.toggleSelectAll(); // 在mounted钩子中调用
  },
  methods: {
    getList() {
      this.listLoading = true;
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      this.listQuery.date_one = this.startDate;
      this.listQuery.date_two = this.endDate;
      const url = this.$root.commonPreUrl + "/index/getSms";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.listLoading = false;
            this.list = resd.data.data;
            this.total = resd.data.total;
            this.list.forEach((item, index) => {
              item.idx = index + 1;
              if (item.express_code_senttime != "") {
                item.express_code_senttime = moment(
                  item.express_code_senttime * 1000
                ).format("YYYY-MM-DD HH:mm:ss");
              }
            });
            this.$nextTick(() => {
              // 在DOM更新后执行
              this.$refs.multipleTable.toggleAllSelection();
            });
          }
        })
        .catch((error) => {
          this.listLoading = false;
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          }
        });
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },

    handleSelectionChange(val) {
      this.multipleSelection = val; // 当选项发生变化时，重新赋值
      this.allSelectedDatas = val;
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        this.$refs.multipleTable.toggleAllSelection();
      });
    },
    smsZdSendInfo() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      this.resetTemp();
      this.dialogFormVisible = true;
      const url = this.$root.commonPreUrl + "/index/sms";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const resData = resd.data;
            this.start_time = resData.dingshi_1;
            this.end_time = resData.dingshi_2;
            // this.dataTemp.dingshi_1 = resData.dingshi_1;
            // this.dataTemp.dingshi_2 = resData.dingshi_2;
            this.dataTemp.day = resData.day;
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    resetTemp() {
      this.dataTemp = {
        dingshi_1: "",
        dingshi_2: "",
        day: 0,
      };
    },

    autoSendSmsOn() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      // 判断 是否已设置时间和天数  若未设置  不能开启
      // if (
      //   this.dataTemp.day == "" ||
      //   this.dataTemp.day == null ||
      //   this.dataTemp.day == undefined ||
      //   this.dataTemp.day == 0 ||
      //   this.dataTemp.day == "0" ||
      //   this.start_time == "" ||
      //   this.start_time == null ||
      //   this.start_time == undefined ||
      //   this.end_time == "" ||
      //   this.end_time == null ||
      //   this.end_time == undefined
      // ) {
      //   this.$confirm("请先设置有效的自动发送时间段和天数后再开启自动发送!", "提示", {
      //     confirmButtonText: "确认",
      //     showCancelButton: false, // 是否显示取消按钮
      //   })
      //     .then(() => {
      //       this.sms_auto = 0;
      //       //this.dialogFormVisible = false;
      //     })
      //     .catch(() => {});
      //   return;
      // }

      if (this.end_time < this.start_time) {
        this.$confirm("截止时间不能早于起始时间，请选择正确的时间段!", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, // 是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => {});
        return;
      }
      this.dataTemp.dingshi_1 = this.start_time;
      this.dataTemp.dingshi_2 = this.end_time;
      // 判断是否已开启  需要先关闭再修改 再重新开启
      const sms_auto = this.sms_auto;
      if (sms_auto == 1 || sms_auto == "1") {
        this.$confirm("短信自动发送已开启，请先关闭后再修改-保存!", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, // 是否显示取消按钮
        })
          .then(() => {
            this.dialogFormVisible = false;
          })
          .catch(() => {});
        return;
      }

      const url = this.$root.commonPreUrl + "/index/autoSendSmsOn";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.dataTemp,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            if (resd.msg == "自动发送短信开启成功！") {
              this.dialogFormVisible = false;
              this.sms_auto = 1;
              this.$notify({
                title: "成功",
                message: "短信自动发送-开启成功",
                type: "success",
                duration: 2000,
              });
              this.resetTemp();
            } else {
              this.$confirm(resd.msg, "提示", {
                confirmButtonText: "确认",
                showCancelButton: false, // 是否显示取消按钮
              })
                .then(() => {})
                .catch(() => {});
            }
          } else {
            this.sms_auto = 0;
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    autoSendSmsOnOff() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      const sms_kg = this.sms_auto;
      if (sms_kg == 0) {
        const url = this.$root.commonPreUrl + "/index/autoSendSmsOff";
        const res = axios.get(url, {
          headers: {
            Authorization: "Bearer " + userToken,
          },
          params: this.dataTemp,
        });
        res
          .then((response) => {
            const resd = response.data;
            if (resd.code == "200") {
              this.$notify({
                title: "成功",
                message: "短信自动发送-关闭成功！",
                type: "success",
                duration: 2000,
              });
            }
            setTimeout(() => {}, 1.5 * 1000);
          })
          .catch((error) => {
            console.error("初始请求失败:", error);
            if (
              JSON.stringify(error).includes("Error: Request failed with status code 401")
            ) {
              this.$confirm("登录信息已失效，请重新登录!", "提示", {
                confirmButtonText: "确认",
                showCancelButton: false, // 是否显示取消按钮
              })
                .then(() => {
                  // 重新导航到首页
                  localStorage.clear();
                  this.$root.removeCookies();
                  this.$router.push({ path: "/login" });
                })
                .catch(() => {});
            }
          });
      } else if (sms_kg == 1) {
        this.autoSendSmsOn("sms_auto");
      }
    },
    sendCsSms() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      const url = this.$root.commonPreUrl + "/index/sendCsSms";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { mobile: this.csPhoneNum },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.$notify({
              title: "成功",
              message: resd.msg,
              type: "success",
              duration: 2000,
            });
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    async sendSms() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // 重新导航到登录页面
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      let data = this.allSelectedDatas;
      if (data == [] || data.length == 0) {
        this.$confirm("请先选择订单再发送短信!", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: undefined, // 取消按钮不显示
        })
          .then(() => {})
          .catch(() => {});
        return;
      }
      let allDatas = [];
      data.forEach((item) => {
        // item.handle_time = "";
        allDatas.push(item);
      });

      this.listLoading = true;
      this.dxfsResult.data = "";
      const url = this.$root.commonPreUrl + "/index/sendSms";
      for (let index = 0; index < allDatas.length; index++) {
        const item = allDatas[index];

        let sdfsParams = JSON.parse(JSON.stringify(this.sdfsQuery));
        let shrList = {
          order_no: item.order_no,
          order_id: item.id,
          express_address: item.express_address,
          express_contact_mobile: item.express_contact_mobile,
          express_company: item.express_company,
          express_code: item.express_code,
          mobile: item.mobile,
          express_pro: item.express_pro,
          express_no: item.express_no,
          express_code_sent: item.express_code_sent,
          cg_platform: this.platList[item.platform],
        };
        sdfsParams.list = JSON.stringify([shrList]);
        sdfsParams = JSON.stringify(sdfsParams);
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userToken,
        };
        await axios
          .post(url, sdfsParams, { headers: headers })
          .then((response) => {
            const resd = response.data;
            if (resd.code == "200") {
              this.dxfsResult.data = this.dxfsResult.data + resd.msg + "；\n";
            } else {
              this.dxfsResult.data = this.dxfsResult.data + resd.msg + " ;\n";
            }
            setTimeout(() => {
              return;
            }, 1.5 * 1000);
          })
          .catch((error) => {
            console.error("初始请求失败:", error);
            if (
              JSON.stringify(error).includes("Error: Request failed with status code 401")
            ) {
              // 重新导航到首页
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
              return;
            }
          });
        if (index == allDatas.length - 1) {
          this.fsjgDialogFormVisible = true;
        }
      }
      // });
      this.getList();
      this.listLoading = false;
    },
  },
};
</script>

<style scoped>
.btncs_blue {
  font-size: 13px;
  background-color: #0850fc;
  color: white;
  height: 38px;
  border-radius: 0.5em;
  margin-left: 59px;
  margin-top: 12px;
}
.btncs_gray {
  font-size: 13px;
  background-color: rgb(187 187 187);
  color: white;
  height: 38px;
  border-radius: 0.5em;
  margin-left: 59px;
  margin-top: 12px;
}
.lipin_img_div {
  width: 5vw;
  height: 5vw;
  /* min-height: 22.5vh; */
  border: white 2px solid;
  border-radius: 1.3em;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  /* background-color: #d5e1ff; */
  color: rgb(37, 37, 37);
  margin-left: 20px;
  margin-top: 0px;
}
.lipin_img {
  width: 4.7vw;
  height: 4.6vw;
  padding-left: 0.1vw;
  margin-top: 0.1vw;
  border-radius: 1em;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
.zfxx {
  /* margin-top: 3px; */
  display: flex;
  align-items: center; /* 垂直居中 */
}
.djb {
  color: rgb(120 120 120);
  margin-left: 10px;
}
.djb_desc {
  font-weight: bold;
  font-size: 15px;
  color: #202020;
  margin-left: 20px;
  padding-top: 3px;
}
.select_span {
  font-size: 14px;
  border: #dcdfe6 1px solid;
  border-radius: 4px;
  height: 32px;
  /* line-height: 34px;
  padding: 11px; */
  color: #606266;
  margin-left: 20px;
  margin-top: 5px;
  padding-bottom: 10px;
}
select {
  height: 30px;
  /* border: #c3c3c3 solid 1px; */
  border: none;
  border-radius: 0.4em;
  outline: none;
}
select:focus {
  outline: none; /* 移除轮廓线 */
}
/* 去掉option的边框 */
option {
  border: none;
  outline: none;
}
.select-option:hover {
  border-color: #0000ff;
  background-color: #ffff00;
}
input {
  height: 30px;
  /* border: #c3c3c3 solid 1px; */
  border: white solid 0px;
  border-radius: 0.4em;
}
input:focus {
  outline: none; /* 移除轮廓线 */
}
.borderless {
  /* border: white 1px solid; */
  box-shadow: none;
  height: 28px;
  width: 170px;
  margin-left: -5px;
  /* margin-top: -3px; */
}

.el-button {
  font-size: 12px;
  border-color: #0850fc; /* 边框颜色 */
  color: white; /* 文字颜色 */
  background-color: #0850fc; /* 默认背景色 */
  height: 34px;
  padding: 10px 12px;
  border-radius: 0.5em;
}
.el-button:hover {
  border-color: #5185ff;
  background-color: #5185ff; /* 悬浮时的颜色 */
}
.platDiv {
  width: 80px;
  height: 32px;
  border: #0850fc solid 1px;
  border-radius: 0.5em;
  float: left;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}
.platSpan {
  font-size: 16px;
  padding: 0px 7px;
}
.spanColors {
  font-weight: bold;
  background-color: #0850fc;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/syncOrder/sms/index.vue